import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
const socialProofData = [{
  name: 'Camila R.',
  city: 'Buenos Aires',
  time: '3 min'
}, {
  name: 'Mateo G.',
  city: 'Bogotá',
  time: '5 min'
}, {
  name: 'Sofía T.',
  city: 'Ciudad de México',
  time: '7 min'
}, {
  name: 'Joaquín M.',
  city: 'Santiago',
  time: '12 min'
}, {
  name: 'Valentina B.',
  city: 'Lima',
  time: '15 min'
}, {
  name: 'Lucas P.',
  city: 'Córdoba',
  time: '18 min'
}, {
  name: 'Isabella S.',
  city: 'Medellín',
  time: '22 min'
}, {
  name: 'Diego C.',
  city: 'Rosario',
  time: '25 min'
}, {
  name: 'Martina L.',
  city: 'Quito',
  time: '28 min'
}, {
  name: 'Tomás F.',
  city: 'Montevideo',
  time: '31 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % socialProofData.length);
      setVisible(true);
    }, 8000);
    return () => clearTimeout(showTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const person = socialProofData[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-260">
      <div className="bg-dark-800 border border-white/10 rounded-xl p-4 pr-10 shadow-2xl shadow-black/50 relative" data-id="element-261">
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Cerrar" data-id="element-262">
          <X className="w-4 h-4" data-id="element-263" />
        </button>
        <div className="flex items-start gap-3" data-id="element-264">
          <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center shrink-0" data-id="element-265">
            <span className="text-emerald-400 text-lg" data-id="element-266">🧠</span>
          </div>
          <div className="flex-1 min-w-0" data-id="element-267">
            <p className="text-sm text-gray-300" data-id="element-268">
              <span className="font-bold text-white" data-id="element-269">{person.name}</span>{' '}
              <span className="text-gray-500" data-id="element-270">desde {person.city}</span>{' '}
              <span className="text-gray-500" data-id="element-271">🌎</span>
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-272">
              Acaba de obtener acceso a{' '}
              <span className="text-gold-400 font-semibold" data-id="element-273">
                Mega Pack · Anatomía Humana
              </span>{' '}
              📘
            </p>
            <p className="text-xs text-gray-500 mt-2 flex items-center gap-1.5" data-id="element-274">
              <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block animate-pulse" data-id="element-275"></span>
              COMPRA VERIFICADA · hace {person.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}